<template>
  <router-view />
</template>

<script>
  export default {
    name: 'Actor'
  }
</script>
